import { useContext, useEffect, useState } from 'react';
import { TaskContext } from '../Insurance';
import { Form } from 'antd';
import { useGetTaskResponsesByTask } from '../../../../services/task/querys';
import { Task, TaskResponse, TaskState } from '../../../../gql/graphql';
import CardUploadResponse from '../../components/Atoms/Cards/CardUploadResponse/CardUploadResponse';
import ActionAcceptAndReject from '../../../ActionAcceptAndReject/ActionAcceptAndReject';

const Documents = () => {
  const [form] = Form.useForm();
  const task: Task | any = useContext(TaskContext);

  const { data: taskResponses, reexecute: getTaskResponses } = useGetTaskResponsesByTask({
    variables: { findResponsesByTask: { taskId: task._id } }
  });

  const [responseInfo, setResponseInfo] = useState<TaskResponse | any>();
  const [responseDoc, setResponseDoc] = useState<TaskResponse | any>();

  useEffect(() => {
    getTaskResponses({ requestPolicy: 'network-only' });
  }, []);


  useEffect(() => {
    if (responseInfo && responseInfo.state !== TaskState.RequestError)
      form.setFieldsValue(responseInfo.metadata);
  }, [responseInfo])

  useEffect(() => {
    const _response = taskResponses?.find((item) => item.step === 2 && item.key === 'insurance-information');
    setResponseInfo(_response);

    const _response2 = taskResponses?.find((item) => item.step === 2 && item.key === 'insurance-doc');
    setResponseDoc(_response2);
  }, [taskResponses]);

  return (
    <div className='mt-30'>
      <CardUploadResponse
        title={'Insurance documents'}
        limitFiles={5}
        files={responseDoc?.files}
        state={responseDoc?.state}
        submit={{
          title: 'Submit for review',
          loading: false,
          disabled: true,
          onClick: () => { }
        }}
        insertHtml={responseDoc &&
          <ActionAcceptAndReject
            taskResponseId={responseDoc?._id}
            task={{ id: task._id, key: task.key, name: task.name }}
            files={responseDoc?.files}
            currentState={responseDoc?.state}
          />
        }
      />
    </div>
  );
};
export default Documents;